var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.resumeName
        ? _c("div", [
            _c("p", { staticClass: "text-gray-500" }, [
              _vm._v("Resume not provided"),
            ]),
          ])
        : _c("UIButton", {
            staticClass: "min-w-full",
            attrs: { buttonText: "Download resume" },
            on: { click: _vm.downloadFile },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }